export default __webpack_public_path__ + "static/media/bg-header_pc.19e5e610.jpg";